// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import { TouchCardKind } from "../../touchCard/common/data/TouchCardKind";
import ShopTouchCardSelectLayer from "./ShopTouchCardSelectLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShopTouchCardSelectItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelHint: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprBlack: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	btnEnter: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGold: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeVideo: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGold: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprBg: cc.Sprite = null;

  
    private lotteryInfo: TouchCardKind.ItemInfo = null;
    private _parent: ShopTouchCardSelectLayer = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(info: TouchCardKind.ItemInfo, _parent: ShopTouchCardSelectLayer) {
        this.lotteryInfo = info;
        this._parent = _parent;
    }

    initUI() {
        this.labelGold.string = data_control.getNumberFormat(this.lotteryInfo.price);
        this.sprBg.node.active = false;
        let path = 'asset/touchCardSelect/' + this.lotteryInfo.icon;
        getOneBundle(BUNDLE_SMALL_NAME.shopGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
            bundle.load(path,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    this.sprBg.spriteFrame = asset;
                    this.sprBg.node.active = true;
                }
            });
        });
        this.refreshState();
    }

    refreshState() {

        let lotteryInfo = this.lotteryInfo;
        let gameData = NormalGameManager._instance.getGameData();
        let bLock = this.lotteryInfo.bLock;
        if (bLock) {
            if (gameData.touchCardLevelLock && gameData.touchCardLevelLock[lotteryInfo.idx]) {
                bLock = false;
            }
        }

        if (bLock) {
            this.sprBlack.node.active = true;
            this.btnEnter.active = false;
        } else {
            this.sprBlack.node.active = false;
            this.btnEnter.active = true;
        }
        
        let count = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
        let bShowVideo = count >= lotteryInfo.limitCount;
        this.nodeVideo.active = bShowVideo;
        this.nodeGold.active = !bShowVideo;
        this.labelGold.node.active = !bShowVideo;

        if (bShowVideo) {
            this.labelHint.string = '再来一次';
        } else {
            this.labelHint.string = '一次';
        }
    }

    onClickEnter() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let lotteryInfo = this.lotteryInfo;
        let gameData = NormalGameManager._instance.getGameData();
        if (this.sprBlack.node.active) {
           
            utilsView.openEventLayer(
                null
                , {
                    id:  lotteryInfo.lockEventId
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        gameData.touchCardLevelLock[lotteryInfo.idx] = true;
                        NormalGameManager._instance.writeGameData();
                        this.refreshState();
                    }
                    , exitLayer: ()=> {
                        
                    }
                }
                , UI_Z_INDEX.DIALOG
            );

            // O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
            return;
        }

        if (this.nodeVideo.active) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.enterLayer();
            },()=>{
                O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
            },()=>{
    
            },"摸牌挑战解锁");
        } else {
            let needPayPrice : number = lotteryInfo.price;
            if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
                
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
            

            
            gameData.curTouchCardNum[lotteryInfo.idx] = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
            gameData.curTouchCardNum[lotteryInfo.idx]++;
            NormalGameManager._instance.writeGameData();
            this.refreshState();
            this.enterLayer();
        } 
    }

    enterLayer() {
        // this._parent.destroyNode();
        O1HD.getModules().uiControlModule.showLoading();
        let lotteryInfo = this.lotteryInfo;
        utilsView.openPopupLayerTwo(
            lotteryInfo.dialogPath
            , null
            , {
                lotteryInfo: this.lotteryInfo
            }
        );
    }

    // update (dt) {}
}
